import { movieApi, tvApi } from "api";
import React from "react";
import DetailPresenter from "./DetailPresenter";

export default class extends React.Component{
    constructor(props){
        super(props);
        
        const {location: {pathname}} = props; //여기서 props 는 아래 this.props
        console.log(pathname);
        this.state = {
            result: null,
            error: null,
            loading: true,
            isMovie: pathname.includes("/movie/") //boolean
        }
    }

    async componentDidMount(){
        // console.log(this.props);
        const {
            match: {params: {id}},
             history: {push},
            } = this.props;
        const {isMovie} = this.state;
        
        const parseId = parseInt(id);
        
        //If is not a number go back to home..;
        console.log(parseId);
        if(isNaN(parseId)){
           return push("/");
        }
        let result = null;
        try{
            if(isMovie){
                ({data: result} = await movieApi.movieDetail(parseId));
                console.log(result);
            }else{
                ({data: result} = await tvApi.showDetail(parseId));
            }
            console.log(result);
        }catch{
            this.setState({error: "cant find anything"});
        }finally{
            this.setState({loading: false, result: result })
            console.log({result} = this.state);
        }
    
        
        }

    render(){
        const {result, error, loading, isMovie} = this.state;
        
        return(
            <DetailPresenter
            result={result}
            error={error} 
            loading={loading}
            isMovie={isMovie}
            />
        )
    }
}
